export enum PriorityEnum {
    P1 = 100,
    P2 = 200,
    P3 = 300,
    P4 = 400,
}

export const PriorityEnumDict = {
    [PriorityEnum.P1]: 'P1',
    [PriorityEnum.P2]: 'P2',
    [PriorityEnum.P3]: 'P3',
    [PriorityEnum.P4]: 'P4',
};
